"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _getProperty = _interopRequireDefault(require("./getProperty"));

var _compatibleGridTemplate = _interopRequireDefault(require("./compatibleGridTemplate"));

var _autoPlacement = _interopRequireDefault(require("./autoPlacement"));

var chooseGap = function chooseGap(specificGap, basicGap) {
  return specificGap && specificGap !== "0" ? specificGap : basicGap;
};

var getViewportIEGridStyles = function getViewportIEGridStyles(mediaQuery, childrenCount, _ref, props) {
  var index = _ref.index,
      devices = _ref.devices;
  var rows = (0, _getProperty.default)("rows", {
    index: index,
    devices: devices
  }, props);
  var columns = (0, _getProperty.default)("columns", {
    index: index,
    devices: devices
  }, props);
  var gap = (0, _getProperty.default)("gap", {
    index: index,
    devices: devices
  }, props);
  var rowGap = chooseGap((0, _getProperty.default)("rowGap", {
    index: index,
    devices: devices
  }, props), gap);
  var columnGap = chooseGap((0, _getProperty.default)("columnGap", {
    index: index,
    devices: devices
  }, props), gap);
  var compatibleColumns = (0, _compatibleGridTemplate.default)(columns, columnGap);
  var compatibleRows = (0, _compatibleGridTemplate.default)(rows, rowGap);
  var childrenPlacement = (0, _autoPlacement.default)(childrenCount, compatibleColumns, compatibleRows, columnGap, rowGap);
  return (0, _styledComponents.css)(["-ms-grid-columns:", ";-ms-grid-rows:", ";", ";"], compatibleColumns, compatibleRows, childrenPlacement);
};

var _default = getViewportIEGridStyles;
exports.default = _default;